import React from 'react';
import WelcomeMessage from './WelcomeMessage';
import MessageBubble from './MessageBubble';
import LoadingIndicator from './LoadingIndicator';
import ErrorDisplay from './ErrorDisplay';

interface MessagesListProps {
  messages: any[];
  isLoading: boolean;
  currentStatus: string | undefined;
  currentTool: string | undefined;
  error: string | null | undefined;
  hasUserInteracted: boolean;
  elapsedTime: number;
  messagesEndRef: React.RefObject<HTMLDivElement | null>;
  onQuickAction: (question: string) => void;
  onClearError: () => void;
  onShowFeedback: () => void;
  t: any;
}

const MessagesList: React.FC<MessagesListProps> = ({
  messages,
  isLoading,
  currentStatus,
  currentTool,
  error,
  hasUserInteracted,
  elapsedTime,
  messagesEndRef,
  onQuickAction,
  onClearError,
  onShowFeedback,
  t
}) => {
  return (
    <div className="flex-1 overflow-y-auto p-2 md:p-3 sm:p-4 lg:p-6 space-y-2 md:space-y-3 sm:space-y-4 bg-gray-50/30 min-h-0">
      {messages.length === 0 && (
        <WelcomeMessage onQuickAction={onQuickAction} t={t} />
      )}

      {messages.map((message) => (
        <MessageBubble 
          key={message.id} 
          message={message} 
          onShowFeedback={onShowFeedback}
          t={t} 
        />
      ))}

      {isLoading && (
        <LoadingIndicator 
          currentStatus={currentStatus}
          currentTool={currentTool}
          elapsedTime={elapsedTime}
          t={t}
        />
      )}

      {error && (
        <ErrorDisplay 
          error={error} 
          onClearError={onClearError} 
          t={t} 
        />
      )}

      <div ref={messagesEndRef} />
    </div>
  );
};

export default MessagesList;